import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { getUser, isUserReady } from '../redux/selectors';
import Button from '../components/Button/Button';

function HomePage(props) {
  const [homeContents, setHomeContents] = useState(
    <p className={'text-center'}>Loading...</p>
  );
  if (props.ready && props.user) {
    window.location.href = '/dashboard';
    return null;
  }
  useEffect(() => {
    if (props.ready && !props.user) {
      setHomeContents(
        <div className={'px-4'}>
          <div
            className={
              'flex gap-3 justify-center max-w-[435px] mx-auto max-tablet:flex-col'
            }
          >
            <Button
              tag={'a'}
              variant={'secondary'}
              to='/Login'
              className={'w-full'}
            >
              Log in
            </Button>
            <Button
              tag={'a'}
              variant={'primary'}
              to='/Login'
              className={'w-full'}
            >
              Sign Up
            </Button>
          </div>
        </div>
      );
    }
  }, [props.user, props.ready]);

  return (
    <div className={'h-full pt-28 text-center'}>
      <header className={'mb-8'}>
        <Link to='/' className={'inline'}>
          <img
            src={
              props.currentList?.whiteLabelInfo?.imageURL || 'img/rr-logo.png'
            }
            alt={
              props.currentList?.whiteLabelInfo?.imageURL
                ? `${props.currentList.authorCompany} logo`
                : 'RumbleRank Logo'
            }
            className={'inline'}
            width={'124'}
            height={'96'}
          />
        </Link>
      </header>
      <iframe
        className={'aspect-video w-[672px] mx-auto max-w-full mb-8'}
        src='https://www.youtube.com/embed/pJmiBvOOiUM'
        title='YouTube video player'
        frameBorder='0'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      ></iframe>
      {homeContents}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    ready: isUserReady(state),
  };
}

export default connect(mapStateToProps, {})(HomePage);
